export default __webpack_public_path__ + "static/media/Swiss-Summer-Scent.7385c6e3.jpg";